module.exports = __webpack_public_path__ + "img/expertIconGrey.79edfc4.svg";